import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader-indicator',
  templateUrl: './loading-indicator.component.html',
})
export class LoaderIndicatorComponent {
  readonly loading = input(false);
}
